import GraphQlService from 'epic-node-services/src/graphql/GraphQlService';
import {ExecutionResult} from 'graphql';

export interface AssociatedOrganization {
    name: string;
    organizationId: string;
    ownerAccountId: string;
    status: string;
    isDeveloper: boolean;
}

export interface ExternalAuth {
    type: string;
    externalAuthId: string;
}

export interface AccountInfo {
    email: string;
    id: string;
    displayName: string;
    country: string;
    lastName: string;
    name: string;
    externalAuths: ExternalAuth[];
    associatedOrganizations: AssociatedOrganization[];
}

export interface MyAccount {
    Account: {
        myAccount: AccountInfo;
    };
}

export interface MyUnlinkedPlatforms {
    Account: {
        myAccount: {
            unlinkedDieselPlatforms: string[];
        };
    };
}

export type MyAccountResponse = ExecutionResult<MyAccount>;
export type MyUnlinkedPlatformsResponse = ExecutionResult<MyUnlinkedPlatforms>;

export const fetchMyAccount = (): Promise<MyAccountResponse> => {
    return GraphQlService.query(`{
            Account {
                myAccount {
                    country
                    displayName
                    email
                    id
                    lastName
                    name
                    tfaEnabled
                    externalAuths {
                        type
                        externalAuthId
                    }
                    associatedOrganizations {
                        name
                        organizationId
                        ownerAccountId
                        status
                        isDeveloper
                    }
                }
            }
        }
        `);
};

export const fetchMyUnlinkedPlatforms = (
    locale: string,
    countryCode: string
): Promise<MyUnlinkedPlatformsResponse> => {
    return GraphQlService.query(
        `
            query accountQuery($locale: String!, $countryCode: String) {
                Account {
                    myAccount {
                        unlinkedDieselPlatforms(
                            countryCode: $countryCode,
                            locale: $locale,
                            newUserOnly: true
                        )
                    }
                }
            }
        `,
        {locale, countryCode}
    );
};

// @depreciated
export default {
    getMyAccount: fetchMyAccount,
    getMyUnlinkedPlatforms: fetchMyUnlinkedPlatforms
};
